import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { initSentry } from './config/sentry';
import './index.css';
import { MapProvider } from './MapContext';
import Auth from './auth/auth';
import KeycloakApisixTest from './auth/KeycloakApisixTest';

// Initialize Sentry error tracking
initSentry();

const APISIX_ROUTE = process.env.APISIX_ROUTE || "/keycloak-apisix";
const container = document.getElementById('root')
const root = createRoot(container);
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>} showDialog>
    <MapProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Auth/>} path="/"/>
          <Route element={<KeycloakApisixTest/>} path="/keycloak-apisix"/>
        </Routes>
      </BrowserRouter>
    </MapProvider>
  </Sentry.ErrorBoundary>
);

